import numeral from 'numeral'
numeral.nullFormat('-')
export const formatThouNum = (num, digit = 0) => {
  let _num = num
  if (num === undefined || num === null) {
    _num = null
  }
  let formatText = '0,0'
  if (digit > 0) {
    formatText += '.'
  }
  for (let i = 0; i < digit; i++) {
    formatText += '0'
  }
  return numeral(_num).format(formatText)
}
